var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormsAutocomplete",
    _vm._b(
      {
        attrs: {
          item: _setup.collection,
          label: _vm.label,
          clearable: _vm.clearable,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          "show-add": _vm.showAdd,
          "error-messages": _vm.errorMessages,
          dense: _vm.dense,
          "store-action": "domainShift/ActionGetShifts",
          filters: _setup.applyFilter,
          "load-data": _vm.loadData,
        },
        on: {
          "update:filters": function ($event) {
            _setup.applyFilter = $event
          },
        },
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      },
      "FormsAutocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }